<template>
	<div class='process-wrap'>
		<table border="0" cellpadding="0" cellspacing="0" width="100%" class="table-tit">
			<tbody>
				<tr>
					<th style="width:15% ">序号</th>
					<th style="width:28% ">材料名称</th>
					<th style="width:35%">描述</th>
					<th style="width:22% ">操作</th>
				</tr>
				<tr v-for="(item, index) in list" :key="index">
					<td>{{item.no}}</td>
					<td v-html="item.name"></td>
					<td v-html="item.desc"></td>
					<td v-if="item.link"><a :href="item.link" v-html="item.fileName"></a></td>
					<td v-else>{{item.fileName}}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>

export default {
	name: 'process',
	components: {},
	data() {
		return {
			list: [
				{
					no: '材料一',
					name: '信用修复承诺书',
					desc: '每条行政处罚申请修复时均须单独出具</br>《信用修复承诺书》 ',
					link: "https://www.creditchina.gov.cn/images/202007/P020200731641826921912.docx",
					fileName: '《信用修复承诺书》</br>(20200801修订版)下载'
				},
				{
					no: '材料二',
					name: '行政相对人主要登记证照复印件</br>加盖公章',
					desc: '主要包括工商营业执照、事业单位法人证书、社会团体法人登记证书、民办非企业单位登记证书、基金会法人登记证书等',
					link: '',
					fileName: '— —'
				}, {
					no: '材料三',
					name: '已履行行政处罚相关证明材料复印件，加盖公章',
					desc: '主要包括缴交罚款收据、行政处罚机关出具的相关证明材料等；处罚类型为警告的可提供已整改说明',
					link: '',
					fileName: '— —'
				}, {
					no: '材料四',
					name: '由行政处罚机关出具的《涉及一般失信行为的行政处罚信息信用修复表》',
					desc: '— —',
					link: 'http://credit.shandong.gov.cn/files/2020/04/20200426114102866.docx',
					fileName: '模板下载'
				}, {
					no: '材料五',
					name: '主动参加信用修复培训的证明材料',
					desc: '可参加公益性培训班或第三方信用服务机构举办得培训班，并取得培训证明。如何参加信用修复培训班详见“常见问答-八',
					link: '',
				}, {
					no: '材料六',
					name: '信用报告',
					desc: '可通过“信用中国”网站及各省级信用门户网站免费下载“公共信用信息概况”（信用报告）或由第三方信用服务机构出具信用报告。如何准备信用报告详见“常见问答-九”',
					link: '',
				}
			]
		}
	},
	created() { },
	mounted() { },
	methods: {},
	computed: {},
	watch: {},
}
</script>
<style lang='scss'>
	.process-wrap {
		width: 100%;

		table {
			margin: 20px 0 30px;
			tr {
				th {
					border-top: 1px solid #cccccc;
					border-bottom: 1px solid #cccccc;
					padding: 15px 30px;
					font-size: 16px;
					font-weight: bold;
					text-align: left;
				}
				td {
					padding: 15px;
					font-size: 16px;
					text-align: left;
					line-height: 24px;
					border-bottom: #e8e8e8 1px solid;
					a {
						color: #0063ba;
						text-decoration: underline;
						font-size: 15px;
					}
				}
				th,
				td {
					&:nth-of-type(1) {
						text-align: center;
					}
				}
			}
		}
	}
</style>